import React, {useEffect, useState} from "react";
import {
    CircularProgress, Icon,
    LinearProgress,
    Paper, Tab,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tabs,
    Typography,
    useTheme
} from "@material-ui/core";
import {motion} from "framer-motion";
import axios from "axios";
import {APPLICATION_STATUS_URL, DOWNLOAD_DOCUMENT_URL} from "../api/constants";
import {saveAs} from 'file-saver';
import Xarrow, {Xwrapper} from "react-xarrows";

const ApplicationStatus = ({applicationNumber}) => {

    const theme = useTheme()

    const [tabValue, setTabValue] = useState(0);
    const [progress, setProgress] = useState(false);
    const [downloadDocumentProgress, setDownloadDocumentProgress] = useState(0);
    const [applicationStatus, setApplicationStatus] = useState({});

    function handleTabChange(event, value) {
        setTabValue(value);
    }

    const getApplicationStatus = () => {
        setProgress(true)
        const params = {application_number: applicationNumber}
        axios.get(APPLICATION_STATUS_URL, {
            params
        }).then(res => {
            setApplicationStatus(res.data)
            setProgress(false)
        }).catch(err => {
            console.log(err)
            setProgress(false)
        })
    }

    // get file API
    const download_document = (name) => {
        setDownloadDocumentProgress(name)
        const params = {application_number: applicationNumber, document_name:name}
        axios.get(DOWNLOAD_DOCUMENT_URL, {
            params,
            responseType: 'blob'
        })
            .then(res => {
                saveAs(res.data, `${applicationNumber}_${name}`);
                setDownloadDocumentProgress(0)
            }).catch(err => {
            setDownloadDocumentProgress(0)
        })
    }

    useEffect(() => {
        getApplicationStatus()
    }, [applicationNumber])

    if (progress) {
        return (
            <div>
                <LinearProgress/>
                <Typography color={"textSecondary"} className='p-4 text-center'>Fetching Application status, Please wait...</Typography>
            </div>
        )
    }

    if (!applicationStatus.application_number) {
        return <Typography className='p-4'>Details not found</Typography>
    }
    return (
        <motion.div
            initial={{y: 30, opacity: 0}}
            animate={{y: 0, opacity: 1, transition: {delay: 0.2}}}>
            <Tabs
                value={tabValue}
                onChange={handleTabChange}
                indicatorColor='primary'
                textColor='primary'
                variant='scrollable'
                scrollButtons='auto'
                classes={{root: 'h-8'}}
            >
                <Tab className='h-8' label='Application Status Details'/>
                <Tab className='h-8' label='Uploaded Documents'/>
            </Tabs>
            <TableContainer className='w-full flex flex-col py-4'>

                <div className={tabValue !== 0 ? 'hidden' : ''}>
                    <Table aria-label='simple table' size={"small"} className='border border-b-0'>
                        <TableBody>
                            <TableRow>
                                <TableCell align='left' style={{minWidth: 150}}>Application Number</TableCell>
                                <TableCell align='left'>{applicationStatus.application_number}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell align='left' style={{minWidth: 150}}>Application Type</TableCell>
                                <TableCell align='left'>{applicationStatus.application_type}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell align='left' style={{minWidth: 150}}>Date of Filing</TableCell>
                                <TableCell align='left'>{applicationStatus.date_of_filing}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell align='left' style={{minWidth: 150}}>Applicant Name</TableCell>
                                <TableCell align='left'>{applicationStatus.applicant_name.split('\n').map(str =>
                                    <p>{str}</p>)}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell align='left' style={{minWidth: 150}}>Title of Innovation</TableCell>
                                <TableCell align='left'>{applicationStatus.title_of_invention}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell align='left' style={{minWidth: 150}}>Email</TableCell>
                                <TableCell align='left'>{applicationStatus.email}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell align='left' style={{minWidth: 150}}>Priority Date</TableCell>
                                <TableCell align='left'>{applicationStatus.priority_date}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell align='left' style={{minWidth: 150}}>Request for Examination</TableCell>
                                <TableCell align='left'>{applicationStatus.request_for_examination_date}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell align='left' style={{minWidth: 150}}>Publication Date</TableCell>
                                <TableCell align='left'>{applicationStatus.publication_date}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell align='left' style={{minWidth: 150}}>Status</TableCell>
                                <TableCell align='left'>
                                    <Typography style={{fontWeight: 500}}>{applicationStatus.status}</Typography>
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                    <div className='flex flex-row space-x-8 justify-around my-8 items-center'>
                        <Typography id='status_map_1' className='p-2' color={applicationStatus.status_map[0]?'primary':'textSecondary'}>Filed</Typography>
                        {/*<div id='' style={{width:24, height:1, backgroundColor:'rgba(0,0,0,0.12)'}}/>*/}
                        <Typography id='status_map_2' className='p-2' color={applicationStatus.status_map[1]?'primary':'textSecondary'}>RQ Filed</Typography>
                        <Typography id='status_map_3' className='p-2' color={applicationStatus.status_map[2]?'primary':'textSecondary'}>Published</Typography>
                        <Typography id='status_map_4' className='p-2' color={applicationStatus.status_map[3]?'primary':'textSecondary'}>Under Examination</Typography>
                        <Typography id='status_map_5' className='p-2' color={applicationStatus.status_map[4]?'primary':'textSecondary'}>Disposed</Typography>
                        <Xarrow start='status_map_1' end='status_map_2' strokeWidth={2} color={applicationStatus.status_map[1]?theme.palette.primary.main:'rgba(0,0,0,0.12)'} dashness={!applicationStatus.status_map[1]}/>
                        <Xarrow start='status_map_2' end='status_map_3' strokeWidth={2} color={applicationStatus.status_map[2]?theme.palette.primary.main:'rgba(0,0,0,0.12)'}  dashness={!applicationStatus.status_map[2]} />
                        <Xarrow start='status_map_3' end='status_map_4' strokeWidth={2} color={applicationStatus.status_map[3]?theme.palette.primary.main:'rgba(0,0,0,0.12)'}  dashness={!applicationStatus.status_map[3]}/>
                        <Xarrow start='status_map_4' end='status_map_5' strokeWidth={2} color={applicationStatus.status_map[4]?theme.palette.primary.main:'rgba(0,0,0,0.12)'}  dashness={!applicationStatus.status_map[4]}/>
                    </div>
                </div>
                <div className={tabValue !== 1 ? 'hidden' : ''}>
                    <Table aria-label='simple table' size={"small"} className='border border-b-0'>
                        <TableHead>
                            <TableRow>
                                <TableCell>Name</TableCell>
                                <TableCell>Uploaded Date</TableCell>
                                <TableCell align='center'>Download</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {applicationStatus.documents.map(item => (
                                <TableRow>
                                    <TableCell align='left' style={{minWidth: 150}}>{item.name}</TableCell>
                                    <TableCell align='left'>{item.date}</TableCell>
                                    <TableCell align='center'>
                                        <Typography hidden={downloadDocumentProgress===item.name} color={"primary"} className='cursor-pointer' onClick={()=>download_document(item.name)}>Download</Typography>
                                        {downloadDocumentProgress===item.name && <CircularProgress size={16} className='text-center'/>}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </div>

            </TableContainer>


        </motion.div>
    )
}

export default ApplicationStatus